import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import * as tslib_1 from "tslib";
import classNames from "classnames";
import React from "react";
import { Generic } from "../../base";
import { initialValue, ModalContext } from "./modal-context";
export var ModalPortal = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(ModalPortal, _React$PureComponent);

  var _super = _createSuper(ModalPortal);

  function ModalPortal() {
    var _this;

    _classCallCheck(this, ModalPortal);

    _this = _super.apply(this, arguments);

    _this.close = function () {
      if (_this.props.onClose !== undefined) {
        _this.props.onClose();
      }
    };

    _this.handleKeydown = function (event) {
      if (_this.props.closeOnEsc === true && event.code === "Escape") {
        _this.close();
      }
    };

    return _this;
  }

  _createClass(ModalPortal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          clipped = _this$props.clipped,
          document = _this$props.document;
      document.addEventListener("keydown", this.handleKeydown);
      var html = document.querySelector("html");

      if (html !== null) {
        if (clipped === true) {
          html.classList.add("is-clipped");
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var document = this.props.document;
      document.removeEventListener("keydown", this.handleKeydown);
      var html = document.querySelector("html");

      if (html !== null) {
        html.classList.remove("is-clipped");
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _a = this.props,
          className = _a.className,
          closeOnBlur = _a.closeOnBlur,
          closeOnEsc = _a.closeOnEsc,
          innerRef = _a.innerRef,
          onClose = _a.onClose,
          rest = tslib_1.__rest(_a, ["className", "closeOnBlur", "closeOnEsc", "innerRef", "onClose"]);

      return React.createElement(ModalContext.Provider, {
        value: {
          close: this.close,
          closeOnBlur: closeOnBlur === true,
          closeOnEsc: closeOnEsc === true
        }
      }, React.createElement(Generic, Object.assign({
        className: classNames("modal", "is-active", className),
        ref: innerRef
      }, rest)));
    }
  }]);

  return ModalPortal;
}(React.PureComponent);
ModalPortal.defaultProps = {
  closeOnBlur: initialValue.closeOnBlur,
  closeOnEsc: initialValue.closeOnEsc
};
ModalPortal.displayName = "Modal.Portal";